// src/pages/WhyNoDirectChat.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./LegalPages.css";

const WhyNoDirectChat = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Why NexterZone Does Not Allow Direct Chat</h1>
        <p>
          NexterZone is designed to reduce fraud, pressure tactics, and unsafe exchanges
          by keeping trade communication on-platform.
        </p>
      </div>

      <div className="legal-grid">
        <section className="legal-card">
          <h2>Reducing scams and manipulation</h2>
          <p>
            Direct messaging is often used to move trades off-platform, pressure users
            into rushed decisions, or bypass safety checks. By removing private chat,
            NexterZone limits these risks.
          </p>
        </section>

        <section className="legal-card">
          <h2>Preventing off-platform deals</h2>
          <p>
            Off-platform communication can lead to untracked payments, unsafe meetups,
            and disputes that the platform cannot verify or resolve. NexterZone keeps
            trades within a controlled process.
          </p>
        </section>

        <section className="legal-card">
          <h2>Clear audit trail</h2>
          <p>
            Trade actions, evidence submissions, inspections, and decisions are recorded
            as part of the workflow. This creates accountability and allows issues to be
            reviewed fairly.
          </p>
        </section>

        <section className="legal-card">
          <h2>How communication works instead</h2>
          <p>
            Users receive official NexterZone notifications at each stage of the trade,
            including offer updates, verification requests, pickup scheduling, and
            completion notices.
          </p>
        </section>

        <section className="legal-card">
          <h2>Does this slow things down?</h2>
          <p>
            In some cases, yes — but the trade-off is improved safety, reduced fraud,
            and clearer outcomes for both buyers and sellers.
          </p>
        </section>

        <section className="legal-card">
          <h2>Related pages</h2>
          <ul className="legal-ol">
            <li>
              <Link to="/help/how-trades-work">How trades work</Link>
            </li>
            <li>
              <Link to="/trust-safety">Trust &amp; Safety</Link>
            </li>
            <li>
              <Link to="/faq">Frequently Asked Questions</Link>
            </li>
          </ul>
        </section>
      </div>

      <div className="legal-footnote">
        NexterZone prioritises safety and accountability over informal communication.
        This design helps protect the community and reduce harmful activity.
      </div>
    </div>
  );
};

export default WhyNoDirectChat;
